import { isOrHandleAsExternalUrl } from "../../../helpers";
import { TLink } from "../../../types/link-types";
import Chip from "../chip/chip";
import Heading from "../heading/heading";
import Link from "../link/link";
import styles from "./navigation-card.module.less";
import { useTranslation } from "react-i18next";

export type TNavigationCardProps = {
  chip?: string;
  heading: string;
  text?: string;
  link?: TLink;
  icon: string;
};

export const NavigationCard = ({ chip, heading, text, link, icon }: TNavigationCardProps) => {
  const { t } = useTranslation();

  return (
    <Link
      url={link?.url}
      className={styles.wrapper}
      ariaLabel={link?.title}
      target={link?.url && isOrHandleAsExternalUrl(link?.url, link?.target) ? "_blank" : "_self"}
    >
      <div className={styles.iconWrapper}>
        {chip && (
          <div className={styles.tagWrapper}>
            <Chip text={chip} />
          </div>
        )}
        <div className={styles.iconInnerWrapper}>
          <span className={[styles.icon, icon].join(" ")} />
        </div>
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <Heading visualType={"h5"} semanticType={"h2"} className={[styles.heading].join(" ")}>
            {heading}
          </Heading>
          {text && <p className={[styles.text, "body-s"].join(" ")}>{text}</p>}
        </div>
        {link && (
          <div className={styles.buttonWrapper}>
            <Link title={link?.title ? link?.title : t("READ_MORE")} />
          </div>
        )}
      </div>
    </Link>
  );
};

export default NavigationCard;
